import * as types from './types'

export default {
  namespaced: true,
  state: {
    savedConditions: null
  },
  mutations: {
    [types.SET_CONDITIONS] (state, value) {
      state.savedConditions = value
    }
  },
  actions: {
    setConditions ({ commit, state }, value) {
      commit(types.SET_CONDITIONS, value)
    }
  },
  getters: {}
}
